export default function MenuDivider(): React.ReactElement {
  return <div className="h-px w-full bg-gray-ghost/20" />
}
